export interface Style {
    fontSize: string;
    fontFamily: string;
    fontStyle: string;
    fontWeight: number;
    fontVariant: string;
}

export const defaultStyle: Style = {
    fontSize: '10px',
    fontFamily: 'sans-serif',
    fontStyle: 'normal',
    fontWeight: 400,
    fontVariant: 'normal',
};

export const getLineHeight = (style: Partial<Style>) =>
    parseInt((style.fontSize ?? defaultStyle.fontSize).replace('px', '')) + 1;
